import React from 'react';
import logo from "../assets/images/logo.png";

const SiteMark = () => {
  return (
    <div className='w-64 h-24 mb-6'>
        <img className='w-[200px]' src={logo} />
    </div>
  );
};

export default SiteMark;